import React, {
    useContext, useState
} from 'react';
import Breadcrumb from 'shared/components/Breadcrumb';
import InstructionForm from './LivePromptInstructionForm';
import {
    Button
} from 'shared/components/ui/button';
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger
} from 'shared/components/ui/tooltip';

import CommonInstructionSelectionModal from '../Common/CommonInstructionSelectionModal';
import {
    RotateCcw
} from 'lucide-react';
import {
    AiLabContext
} from 'builders/builderInternal/context/AiLabContext';

const LivePrompt = () => {
    const [openSelection, setOpenSelection] = useState(false);
    const [loadedInstruction, setLoadedInstruction] = useState(null);
    const {
        state, dispatch, modelProviders, handleReloadModels
    } = useContext(AiLabContext);

    const form = state?.promptLab?.form;

    const setForm = (field, value) => {
        dispatch({
            type: 'UPDATE_FIELD',
            field,
            value,
        });
    };

    const handleClearForm = () => {
        dispatch({
            type: 'RESET_FORM'
        });
        setLoadedInstruction(null);
    };

    return (
        <div className="flex flex-col w-full h-full p-6">
            <div className='my-1 px-1'>
                <Breadcrumb maxPaths={2} />
            </div>
            <div className="flex flex-row justify-between items-center my-4">
                <h1 className="text-xl font-bold">Prompt Lab</h1>
                <div className='flex flex-row items-center justify-center gap-2'>

                    <TooltipProvider>
                        <Tooltip>
                            <TooltipTrigger asChild>
                                <Button variant="outline" size="icon" onClick={handleClearForm}>
                                    <RotateCcw className='w-5 h-5' />
                                </Button>
                            </TooltipTrigger>
                            <TooltipContent>
                                <p>Clear all fields</p>
                            </TooltipContent>
                        </Tooltip>
                    </TooltipProvider>

                    <Button onClick={() => { setOpenSelection(true); }}>
                        Load Instruction
                    </Button>
                </div>
            </div>

            {/* Instruction Form */}
            <div className="flex-1 overflow-hidden">
                <InstructionForm
                    modelProviders={modelProviders}
                    handleReloadModels={handleReloadModels}
                    form={form} setForm={setForm}
                    loadedInstruction={loadedInstruction}
                    setLoadedInstruction={setLoadedInstruction} />
            </div>

            {/* Instruction Selection Modal */}
            {openSelection && (
                <CommonInstructionSelectionModal
                    setForm={setForm}
                    openModal={openSelection}
                    setOpenModal={setOpenSelection}
                    onLoadInstruction={setLoadedInstruction}
                />
            )}
        </div>
    );
};
export default LivePrompt;
